//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'


const selectoreWidgets = (state) => state.widgetWheelReducer;
const selectorWidgetGroup = (state) => state.widgetGroupReducer;
const selectorStationGroup = (state) => state.widgetStationReducer;

export const useWidgetWheel = () => {   
    const selectedData = useSelector(selectoreWidgets, shallowEqual)
    return selectedData;
}

export const useWidgetGroup = () => {
    const selectedData = useSelector(selectorWidgetGroup, shallowEqual)
    return selectedData;
}

export const useWidgetStation = () => {
    const selectedData = useSelector(selectorStationGroup, shallowEqual)
    return selectedData;
}
